import { db } from '../store/db'
import { Message } from '../store/dbTypes'

export const getQueuedMessages = async () => {
  const appStatus = await db.appStatus.get('Tripsheets')
  return appStatus?.messagesQueue || []
}

export const addQueuedMessage = async (message: Message) => {
  const appStatus = await db.appStatus.get('Tripsheets')
  if (!appStatus) throw new Error('Dexie is missing AppStaus')
  const updatedQueue = [...(appStatus.messagesQueue || []), message]
  await db.appStatus.update('Tripsheets', { messagesQueue: updatedQueue })
}

export const removeQueuedMessage = async (message: Message) => {
  const appStatus = await db.appStatus.get('Tripsheets')
  const updatedQueue = (appStatus?.messagesQueue || []).filter(
    (m) => m.messageId !== message.messageId
  )
  await db.appStatus.update('Tripsheets', { messagesQueue: updatedQueue })
}
